import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription }   from 'rxjs/Subscription';
import { Router } from '@angular/router';

import { AuthService } from '../../../../../providers/auth.service';
import { SharedClientService } from '../../../../client/shared/services/shared-client.service';
import { NotificationService } from './../../notification.service';
import { CookieService } from '../../../../../providers/cookie.service';

import * as moment from 'moment-timezone';


export class NotificationBarClientComponent implements OnInit, OnDestroy {

	public notifications: any[] = [];

	private client;
	private notificationServiceSubscription: Subscription;
	private clientActionsSubscription: Subscription;

	private loadingNotifications: boolean;
	private notificationsBarReloaded: boolean = false;

	constructor(
		private authService: AuthService,
		private cookieService: CookieService,
		private notificationService: NotificationService,
		private sharedClientService: SharedClientService) { }

	// Lifecycle Events
	public ngOnInit(): void {
		this.checkClientNotifications();

		this.notificationServiceSubscription = this.notificationService.emitEventAction$.subscribe(
			(action) => {
				this.fetchEventActions(action);
			}
		);
	}

	public ngOnDestroy(): void {
		if (this.notificationServiceSubscription) {
			this.notificationServiceSubscription.unsubscribe();
		}
		if (this.clientActionsSubscription) {
			this.clientActionsSubscription.unsubscribe();
		}
	}

	private fetchEventActions(actionData: any): void {
		if (typeof actionData === 'object' && actionData.action) {
			switch (actionData.action) {
				case 'remove-notification':
					if (actionData.data.identifier) {
						const idx = this.notifications.findIndex((item) => item.notification_type === actionData.data.identifier);
						if (idx !== -1) {
							this.notifications.splice(idx, 1);
						}
					}
					break;

				case 'reload-notifications':
					if (!this.loadingNotifications) {
						this.notificationsBarReloaded = true;
						this.loadingNotifications = true;
						this.notifications = [];
						this.checkClientNotifications();
					}

					break;

				default:
					break;
			}
		}
	}

	// Services

	private checkClientNotifications(): void {
		this.sharedClientService.get(this.authService.userId).subscribe(
			(client) => {
				const appCookie = this.cookieService.get();
				if ((client.timezone !== moment.tz.guess()) && (!appCookie.timezoneSettings || appCookie.timezoneSettings.showTimezoneConflict)) {
					this.notifications.push({
						accountTimezone: client.timezone,
						browserTimezone: moment.tz.guess(),
						notification_type: 'timezone-conflict'
					});
				}

				if (client.status === 'current-client|not-approved') {
					this.notifications.push({
						notification_type: 'client-speedup-activation'
					});
				}

				this.client = client;
				this.loadingNotifications = false;
			},
			() => {
				this.loadingNotifications = false;
			}
		);
	}
static ctorParameters() { return [ { type: AuthService }, { type: CookieService }, { type: NotificationService }, { type: SharedClientService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/shared/notification/bar/client/bar.component.ts